export const AppConfig = {
  playerApiBaseUrl: `/api/player-api`,
  apiBaseUrl: `/api`,
};
